import axios from 'axios';

/**
 * @param {'cargo' | 'vessel' | 'tc' | 'sales'} type 
 * @param {object} request 
 * @returns 
 */
export async function saveRequestsDataCreated(type, request) {
    return axios({
        method: 'post',
        url: `/api/v1/mails/requestsData/created/${type}`,
        withCredentials: true,
        data: request,
    })
        .then(response => response.data)
        .catch(response => response.data);
}

/**
 * @param {'cargo' | 'vessel' | 'tc' | 'sales'} type 
 * @param {{ mailId: string }} request 
 * @returns 
 */
export async function saveRequestsDataDeleted(type, request) {
    return axios({
        method: 'post',
        url: `/api/v1/mails/requestsData/deleted/${type}`,
        withCredentials: true,
        data: request,
    })
        .then(response => response.data)
        .catch(response => response.data);
}




// WEBPACK FOOTER //
// ./app/services/orders.js